<template>
  <v-app>
    <router-view name="header"></router-view>
    <v-content style="background-color: #ebedf0">
      <router-view></router-view>
    </v-content>
  </v-app>
</template>

<script>
export default {
  name: 'App',
  components: {},
};
</script>
